<template>
  <el-dialog
    title="Crear Interaccion"
    ref="drawerInteractionForm"
    :visible.sync="showDialogVisibleNewInteraction"
    width="35%"
    :before-close="handleClose"
    :append-to-body="appendToBoddy"
  >
    <el-form
      :model="newInteractionForm"
      :rules="rules"
      ref="newInteractionForm"
      label-width="150px"
      class="demo-ruleForm"
      label-position="left"
    >
      <el-form-item label="Tipo de interaccion" prop="InteractionTemplateCode">
        <el-select
          v-model="newInteractionForm.InteractionTemplateCode"
          placeholder="Tipo de interaccion"
          clearable
          filterable
        >
          <el-option
            v-if="isVisit"
            :key="list_interaction_code_to_select[8].value"
            :label="list_interaction_code_to_select[8].label"
            :value="list_interaction_code_to_select[8].value"
          ></el-option>
          <el-option
            v-else-if="isInHours"
            :key="list_interaction_code_to_select[4].value"
            :label="list_interaction_code_to_select[4].label"
            :value="list_interaction_code_to_select[4].value"
          ></el-option>
          <el-option
            v-else-if="isCall"
            :key="list_interaction_code_to_select[3].value"
            :label="list_interaction_code_to_select[3].label"
            :value="list_interaction_code_to_select[3].value"
          >
          </el-option>
          <el-option
            v-else
            v-for="item in list_interaction_code_to_select"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Producto" prop="ProductCode">
        <el-select
          clearable
          filterable
          default-first-option
          v-model="newInteractionForm.ProductCode"
          placeholder="Producto"
        >
          <el-option
            v-for="item in list_products"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Inciada por" prop="InitiatedBy">
        <el-select
          v-model="newInteractionForm.InitiatedBy"
          placeholder="Inciada por"
          clearable
          filterable
        >
          <el-option
            v-for="item in newInteractionForm.InitiatedByItems"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="Contacto" prop="Code">
        <el-select
          v-model="newInteractionForm.Code"
          placeholder="Contacto"
          clearable
          filterable
        >
          <el-option
            v-for="item in listContact"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
          <!-- <el-option
            v-for="item in contactByCust"
            :key="item.ContactCode"
            :value="item.ContactCode"
            :label="item.Name"
          ></el-option> -->
        </el-select>
      </el-form-item>

      <el-form-item label="Objetivo" prop="Subject">
        <el-input v-model="newInteractionForm.Subject"></el-input>
      </el-form-item>

      <!-- <el-form-item label="Conclusion" prop="Description">
        <el-input v-model="model.Description" type="textarea"></el-input>
      </el-form-item> -->
      <el-form-item label="Fecha de creación" prop="creationDate">
        <div class="block">
          <!-- <span class="demonstration">Emits Date object</span>
          <div class="demonstration">Value: {{ value1 }}</div> -->
          <el-date-picker
            v-model="newInteractionForm.creationDate"
            type="date"
            placeholder="Seleccionar Fecha"
            format="dd/MM/yyyy"
          >
          </el-date-picker>
        </div>
      </el-form-item>

      <el-row>
        <el-col>
          <h3>Descripción de la interacción</h3>
          <el-form-item label-width="0" prop="Description">
            <quill-editor
              ref="myQuillEditor"
              v-model="newInteractionForm.Description"
              style="height: auto; margin-bottom: 10px"
            ></quill-editor>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button
        type="primary"
        @click="submitForm('newInteractionForm')"
        v-loading="loading"
        >Crear</el-button
      >
      <el-button @click="handleClose">Cancelar</el-button>
    </span>
  </el-dialog>
</template>

<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import { quillEditor } from "vue-quill-editor";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "DialogNewInteractionForm",
  props: {
    appendToBoddy: {
      type: Boolean,
      default: false,
      required: false
    },
    CustomerData: {
      type: Object
    },
    isCall: {
      type: Boolean
    },
    isVisit: {
      type: Boolean
    },
    isInHours: {
      type: Boolean
    },
    isItVisible: {
      type: Boolean,
      default: false,
      required: false
    },
    dealId: {
      type: Number,
      default: 0,
      required: false
    },
    isProspect: {
      type: Boolean,
      default: false,
      required: false
    },
    clientCode: {
      type: String,
      default: "",
      required: false
    }
  },
  components: {
    quillEditor
  },
  data() {
    return {
      contactByCust: "",
      showDialogVisibleNewInteraction: false,
      newInteractionForm: {
        Description: "",
        Subject: "",
        InteractionTemplateCode: "",
        ProductCode: "",
        InitiatedByItems: [
          {
            label: "Tennos Business",
            value: 0,
            IsEnable: true
          },
          {
            label: "Cliente / Contacto",
            value: 1,
            IsEnable: true
          }
        ],
        InitiatedBy: 0,
        ContactCode: "",
        Code: "",
        creationDate: ""
      },
      model2: {
        Description: "",
        Subject: "",
        InteractionTemplateCode: "",
        ProductCode: "",
        InitiatedByItems: [
          {
            label: "Tennos Business",
            value: 0,
            IsEnable: true
          },
          {
            label: "Cliente / Contacto",
            value: 1,
            IsEnable: true
          }
        ],
        InitiatedBy: 0,
        ContactCode: "",
        Code: "",
        creationDate: ""
      },
      rules: {
        InteractionTemplateCode: [
          {
            required: true,
            message: "El tipo de interaccion es requerido",
            trigger: "change"
          }
        ],
        ProductCode: [
          {
            required: true,
            message: "El producto es requerido",
            trigger: "change"
          }
        ],
        InitiatedBy: [
          {
            required: true,
            message: "Iniciado por es requerido",
            trigger: "change"
          }
        ],
        Code: [
          {
            required: true,
            message: "El código es requerido",
            trigger: "change"
          }
        ],
        Subject: [
          {
            required: true,
            message: "El asunto es requerido",
            trigger: "change"
          }
        ],
        creationDate: [
          {
            required: true,
            message: "La fecha de creación es requerida",
            trigger: "change"
          }
        ],
        Description: [
          {
            required: true,
            message: "La descripcion de la tarea es requerida",
            trigger: "change"
          }
        ]
      },
      companyId: this.$store.state.user.user.CompanySelected
    };
  },
  async mounted() {
    await this.getIterationList();
    await this.getAllProducts();

    if (this.isProspect) {
      await this.getByProspectCode({
        contactCode: this.clientCode
      });
    } else {
      await this.getByCustomerCode({
        customerCode: this.clientCode
      });
    }
  },
  computed: {
    ...mapGetters({
      listContact: "contact/list_to_select",
      list_interaction_code_to_select:
        "interactions/list_interaction_code_to_select",
      list_products: "products/list_products",
      loading: "contact/isLoading"
    }),
    isThisVisible() {
      return this.isItVisible;
    }
  },
  methods: {
    ...mapActions({
      getByCustomerCode: "contact/getByCustomerCode",
      getByProspectCode: "contact/getByProspectCode",
      getIterationList: "interactions/get_interaction_code",
      getAllProducts: "products/all"
    }),
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (this.newInteractionForm.Description == "") {
          this.$message({
            type: "error",
            message: "La Descripcion es requerida"
          });
        }
        if (valid) {
          const date = this.$now();
          this.$store
            .dispatch("interactions/create", {
              ContactNumber: this.newInteractionForm.Code,
              ContactCompanyNumber: this.clientCode,
              Date: this.newInteractionForm.creationDate,
              Description: this.newInteractionForm.Description.replace(
                "<p>",
                ""
              ).replace("</p>", ""),
              InitiatedBy: this.newInteractionForm.InitiatedBy,
              InteractionTemplate:
                this.newInteractionForm.InteractionTemplateCode,
              Subject: this.newInteractionForm.Subject,
              UserName: this.currentUser.UserName,
              Time: date,
              ProductCode: this.newInteractionForm.ProductCode,
              UserID: this.currentUser.UserID,
              CustomerServiceExec_: this.currentUser.CustomerServiceExec_,
              SalesPersonCode: this.CustomerData.SalesPersonCode,
              CompanyId: this.currentUser.CompanySelected,
              DealsId: this.dealId
            })
            .then(() => {
              this.showDialogVisibleNewInteraction = false;
              this.$emit("refreshInteraction");
              this.$message({
                type: "success",
                message: "Interaccion creada!"
              });
              this.handleClose();
            });
        } else {
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    handleClose(done) {
      this.resetForm("newInteractionForm");
      this.showDialogVisibleNewInteraction = false;
      this.$emit("closeIteractionsDialog");

      done();
    },
    show(clientCode, isProspect = false) {
      this.isProspect = isProspect;
      this.clientCode = clientCode;
      this.newInteractionForm = this.model2;
      this.showDialogVisibleNewInteraction = true;
    }
  },

  watch: {
    isInHours(val) {
      this.model2.InteractionTemplateCode = val == true ? "LLAMADA_SO" : "";
      this.model2.InitiatedBy = val == true ? 1 : 0;
    },
    clientCode(val) {
      if (this.isProspect) {
        this.getByProspectCode({
          contactCode: val
        });
      } else {
        this.getByCustomerCode({
          customerCode: val
        });
      }
    },
    listContact(val) {
      if (val.length <= 0) {
        // this.$alert("Este prospecto no tiene contacto.", "", {
        //   type: "warning"
        // });
        // this.showDialogVisibleNewInteraction = false;
      }
    },
    isThisVisible(val) {
      if (val) {
        this.newInteractionForm = this.model2;
      }

      this.showDialogVisibleNewInteraction = val;
    }
  }
};
</script>
